import * as React from "react";
import * as moment from 'moment'
import * as qs from 'query-string'
import { Library, Platform } from "./platform";
export interface FilterParams {
    start_date: Date
    end_date: Date
    platform: Platform
    library?: Library

    setFinancialMode: (activate: boolean) => void
}

export function compareFilterCtxEqual(ctx1: FilterParams, ctx2: FilterParams) {
    return ctx2.end_date.getTime() == ctx1.end_date.getTime()
        && ctx2.start_date.getTime() == ctx1.start_date.getTime()
        && comparePlatformCtxEqual(ctx1, ctx2) && compareLibraryCtxEqual(ctx1, ctx2)
}
export function comparePlatformCtxEqual(ctx1: FilterParams, ctx2: FilterParams) {
    return ctx1.platform == ctx2.platform
}
export function compareLibraryCtxEqual(ctx1: FilterParams, ctx2: FilterParams) {
    return ctx1.library == ctx2.library
}
const query = qs.parse(location.search)

export const InitialFilterValues: FilterParams = {
    start_date: query.start_date ? new Date(query.start_date) : moment().add(-15, 'days').startOf('day').toDate(),
    end_date: query.end_date ? new Date(query.end_date) : moment().add(-1, 'day').endOf('day').toDate(),
    platform: query.platform || 'supreme',
    library: query.library || undefined,
    setFinancialMode: () => {
    }
}

const context = React.createContext<FilterParams>(InitialFilterValues)
export const FilterContextProvider = context.Provider
export const FilterContextConsumer = context.Consumer

export const FilterContextType = context


// WEBPACK FOOTER //
// ./src/components/context/filter.ts